import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class MovuRobotics_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public MovuRobotics: MovuRobotics_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

